/* eslint-disable import/no-anonymous-default-export */
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default () => {
  const location = useLocation();

  useEffect(() => {
    const currentBasePath = location.pathname;
    const currentFullPath = `${location.pathname}${location.search}${location.hash}`;

    // Pobieramy poprzednio zapisaną bazową ścieżkę
    const storedBasePath = sessionStorage.getItem("currentPathBase");

    // Jeśli bazowy adres uległ zmianie, zapisujemy poprzednią pełną ścieżkę
    if (storedBasePath && storedBasePath !== currentBasePath) {
      const storedFullPath = sessionStorage.getItem("currentPath");
      if (storedFullPath) {
        sessionStorage.setItem("previousPath", storedFullPath);
      }
    }

    // Zapisujemy aktualny pełny adres oraz bazowy adres
    sessionStorage.setItem("currentPath", currentFullPath);
    sessionStorage.setItem("currentPathBase", currentBasePath);
  }, [location.pathname, location.search, location.hash]);
};
